// @ts-nocheck

import React, { useEffect, forwardRef, useRef } from 'react';
import { Group, Rect, Text } from 'react-konva';

const TextWithBackground = forwardRef(function TextWithBackground(props, ref) {
  const {
    x = 0,
    y = 0,
    text,
    width,
    paddingTopBottom = 0,
    paddingLeftRight = 0,
    marginBottom = 0,
    fill = '#fff',
    backgroundColor = null,
    cornerRadius = 0,
    fontSize,
    lineHeight,
    fontFamily,
    align = 'left',
  } = props;
  const [box, setBox] = React.useState(null);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) setBox(textRef.current.getClientRect());
  }, []);

  return (
    <Group ref={ref}>
      {backgroundColor && box && (
        <>
          <Rect
            x={x}
            // FIXME we should not substract padding here but add it on the Text Element
            y={y - paddingTopBottom}
            width={box.width + paddingLeftRight * 2}
            height={box.height + paddingTopBottom * 2}
            fill={backgroundColor}
            cornerRadius={cornerRadius}
          />
          {/* margin bottom */}
          <Rect
            x={x}
            y={y + box.height + paddingTopBottom}
            width={box.width + paddingLeftRight * 2}
            height={marginBottom}
          />
        </>
      )}
      <Text
        ref={textRef}
        x={x + paddingLeftRight}
        y={y}
        fill={fill}
        text={text}
        width={width}
        fontSize={fontSize}
        lineHeight={lineHeight}
        fontFamily={fontFamily}
        align={align}
      />
    </Group>
  );
});

export default TextWithBackground;
